export enum AddonsIdentifiersEnum {
    INTENT = 'intent',
    SALESINTELINTENT = 'salesintelintent',
    BOMBORA_INTENT = 'intent',
    VISITORINTEL = 'visitorintel',
}
